import { createWordpressApi } from '@big-d-companies/network'

const wordpressApi = createWordpressApi({
  graphqlUrl: process.env.GRAPHQL_URL,
  username: process.env.WP_CREDENTIALS_USER,
  password: process.env.WP_CREDENTIALS_PASSWORD,
})

const sendNwReq = (query, variables = {}) => wordpressApi.request(query, variables)
const sendNwReqWithAuth = (query, variables = {}) => wordpressApi.requestWithAuth(query, variables)

export { sendNwReq, sendNwReqWithAuth }
